export default "__VITE_ASSET__BMflwh6D__"